import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { Case } from '../../../../shared/api/hscan/case';
import {
  MobileTable,
  MobileTableRow,
} from '../../common/components/MobileTable';
import { TableAndElementInformation } from '../../common/components/SortableTable/PresentationalTable';
import { ElementWrapper } from '../../common/components/SortableTable/RenderTable';
import { useModalityLabel } from '../../hooks/modalityHook';
import {
  TableContext,
  TableElementContext,
  TableElementInformationProvider,
} from '../ImageList/ImageListTable';

const ElementContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const ElementNumber = styled.div`
  width: fit-content;
  padding: 10px;
  border-radius: 4px 4px 0px 0px;
  border: 1px solid #e7e7e7;
  background-color: #f3f4f6;
  color: #a3a6ab;
  font-size: 15px;
  font-weight: bold;
  box-sizing: border-box;
`;

export const MobileSelectedImageTableElement = (
  props: TableAndElementInformation<Case, 'caseId'>,
) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.sendImages.imageTable',
  });
  const modalityLabel = useModalityLabel();

  const { element, elementIndex } = props;

  return (
    <ElementContainer>
      <ElementNumber>{elementIndex + 1}</ElementNumber>
      <MobileTable>
        <tbody>
          <MobileTableRow label={`${t('header.institutionName')}`}>
            {element.institutionName ?? ''}
          </MobileTableRow>
          <MobileTableRow label={`${t('header.studyDate')}`}>
            {element.studyDate ?? ''}
          </MobileTableRow>
          <MobileTableRow label={`${t('header.modality')}`}>
            {modalityLabel(element.modality)}
          </MobileTableRow>
          <MobileTableRow label={`${t('header.bodyPart')}`}>
            {element.bodyPart?.join(', ') ?? ''}
          </MobileTableRow>
        </tbody>
      </MobileTable>
    </ElementContainer>
  );
};

const MobileImageTableEmpty = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.sendImages.imageTable',
  });

  return <div>{t('row.noEntry')}</div>;
};

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  max-height: 326px;
  padding: 5px;
  overflow: auto;
`;
export const MobileSelectedImageTable = () => {
  const { data, identifyKey } = useContext(TableContext);
  return (
    <TableContainer>
      {data.length === 0 && <MobileImageTableEmpty />}
      {data.map((element, elementIndex) => (
        <TableElementInformationProvider
          key={`${element[identifyKey]}`}
          element={element}
          elementIndex={elementIndex}>
          <ElementWrapper
            tableContext={TableContext}
            elementContext={TableElementContext}
            Element={MobileSelectedImageTableElement}
          />
        </TableElementInformationProvider>
      ))}
    </TableContainer>
  );
};
